import { render, staticRenderFns } from "./OfferLetter.vue?vue&type=template&id=53759b42"
import script from "./OfferLetter.vue?vue&type=script&lang=js"
export * from "./OfferLetter.vue?vue&type=script&lang=js"
import style0 from "./OfferLetter.vue?vue&type=style&index=0&id=53759b42&prod&soped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports